module.exports = __webpack_public_path__ + "resources/img/img-glassdome-omnibus-m-jp.2b3057a2d6450097d0e572cb49b17761.png";